<div class="autocomplete">
  <div
    [class.pressed]="showDropdown"
    class="iv-select"
  >
    <input
      (keyup)="search()"
      [(ngModel)]="searchValue"
      class="autocomplete__input"
      placeholder="Type a Ticker/Root/Service"
      value="{{getValue(selectedData)}}"
    >
    <i
      class="autocomplete__toggle material-icons"
      (click)="toggleDropdown($event)"
    ></i>
  </div>

  <dx-scroll-view
    class="autocomplete__list"
    [class.mac]="isMac"
    *ngIf="showDropdown"
    [height]="'100%'"
    [width]="'100%'"
    direction="Both"
  >
    <div
      class="item-container"
      (click)="onItemClick($event, item)"
      statistic
      statisticElementName="Click new tab dropdown"
      *ngFor="let item of filteredData; index as i"
    >
      <ng-container *ngIf="item.stockId || item.underlyingId">
        <div class="item">
          <div class="item__name-and-exchange">{{item.nameAndExchange}}</div>
          <div class="item__region">
            {{getStockType(item)}} - {{item.region}}
          </div>
        </div>

        <div class="company">
          <div class="company__name" title="{{item.company ? item.company : item.name}}">
            {{item.company ? item.company : item.name}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="item.serviceId">
        <div class="item">
          <span class="item__name-and-exchange">{{item.name}}</span>
          <span class="item__region">Service</span>
        </div>
      </ng-container>
    </div>
  </dx-scroll-view>
</div>

<button
  statistic
  statisticElementName="Click new tab add service"
  (click)="onAddClick()"
  [disabled]="!selectedData"
  class="add-button iv-flat-button"
  type="button"
>Add
</button>
